import { gql } from '../../../../../hooks'

export const DELETE_PROTOCOLS = gql`
  mutation AdministrationDeleteLubricantProtocols($id: ID!) {
    aDelete(path: "lubricant/protocols", id: $id) {
    }
  }
`

export const LIST_PROTOCOLS = gql`
  query AdministrationListLubricantProtocols(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "lubricant/protocols"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
